
let currentProduct;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});


const waitForElement = (selector, timeout = 10000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};


// START A/B SECTION

await waitForMazingFunction;
await waitForElement('button[data-add-to-cart-text="Add to cart"]');
mazingSetAB({
    enabled: true,
    addToCartListeners: (callback) => {

        document.querySelector('button[data-add-to-cart-text="Add to cart"]').addEventListener('click', () => {
            console.log('MAZING: addToCartClicked A/B');
            callback();
        });

        return true;
    }
});


// END A/B SECTION


const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;
    console.log('Base SKU:', currentProduct.toLowerCase());

    if (currentProduct !== 'flower-market-vintage-paris-exhibition-mid-century-posters-in-neutral-colours' &&
        currentProduct !== 'flower-market-paris-exhibition-wall-art-prints-framed-in-neutral-colours' &&
        currentProduct !== 'flower-market-vintage-paris-exhibition-mid-century-canvas-art-prints-302b' &&
        currentProduct !== 'botanical-set-of-3-green-and-gold-floral-wall-art-prints' &&
        currentProduct !== 'botanical-set-of-3-green-and-gold-floral-framed-wall-art-prints' &&
        currentProduct !== 'minimal-green-and-gold-set-of-3-botanical-canvas-wall-art') {
        console.log('Not selected Product, skip mazing.')
        return 'xxxxxxxxxxxxxxxx'
    }

    const sizeFieldset = document.querySelector('fieldset[data-option="Size"]');
    const frameFieldset = document.querySelector('fieldset[data-option="Framing Options"]');


    function attachLabelClickListeners(optionContainer) {
        if (!optionContainer) return;
        if (optionContainer.dataset.listenerAttached === 'true') return;

        const labels = optionContainer.querySelectorAll('label');
        labels.forEach(label => {
            label.addEventListener('click', () => {
                setTimeout(() => mazingRefreshSKU(getCurrentSKU(), 'ARTZEWALLART'), 100)
            });
        });

        optionContainer.dataset.listenerAttached = 'true';
    }

    if (sizeFieldset) {
        const optionContainer = sizeFieldset.querySelector('.option-selector__btns');
        const checkedInput = optionContainer?.querySelector('input:checked');
        const selectedValue = checkedInput?.value;

        currentProduct += `-${selectedValue.trim().split('(')[0].trim().replace(/\s+/g, '-')}`
        console.log('Current Size', selectedValue.trim().split('(')[0].trim().replace(/\s+/g, '-'));

        attachLabelClickListeners(optionContainer);
    }

    if (frameFieldset) {
        const optionContainer = frameFieldset.querySelector('.option-selector__btns');
        const checkedInput = optionContainer?.querySelector('input:checked');
        const selectedValue = checkedInput?.value;

        currentProduct += `-${selectedValue.trim().split('(')[0].trim().replace(/\s+/g, '-')}`
        console.log('Current Frame Option', selectedValue.trim().split('(')[0].trim().replace(/\s+/g, '-'));

        attachLabelClickListeners(optionContainer);
    }


    console.log('Final SKU:', currentProduct.toLowerCase());


    return currentProduct.toLowerCase();
};


const initializeMazing = async (placementSelector) => {
    await mazing({
        customerName: 'ARTZEWALLART',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    position: absolute;
                    bottom: 10px;
                    width: 100%;
                    justify-content: center;
                }
                
                .mazing-threed-btn {
                    margin-left: 8px;
                }
                
                .mazing-ar-btn {
                    margin-right: 8px;
                }
                
                .mazing-threed-btn-text{
                    color: #3b4560;
                }
                
                .mazing-ar-btn-text{
                    color: #3b4560;
                }
                
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(27%) sepia(36%) saturate(480%) hue-rotate(185deg) brightness(85%) contrast(90%);
                } 
                
                .mazing-ar-btn-icon {
                    filter: brightness(0) saturate(100%) invert(27%) sepia(36%) saturate(480%) hue-rotate(185deg) brightness(85%) contrast(90%);
                }
            `,
            placementSelector,
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        en: "View in Room",
                        de: "Im Raum anzeigen",
                        fr: "Voir dans votre espace",
                        es: "Ver en tu espacio"
                    };
                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing v 1.0 initialized for:', placementSelector);
};

const cleanupMazing = () => {
    document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
    document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());
};

let styleSet = false;

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        cleanupMazing();
        await initializeMazing('.main-image');

        if (styleSet) {
            return;
        }
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = `
            #mazing-popup-container {
                position: absolute !important;
            }
        `;
        document.head.appendChild(styleSheet);
        styleSet = true;

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();